import gql from 'graphql-tag';

export const add = gql`mutation CreateFile($file: FileInput!) {
    createFile(file: $file) {
        id
        fog_id
        path
        mimetype
        name
        size
        deleted
    }
}`;


export const edit = gql`mutation EditFile($id: ID!, $file: FileInput!) {
    editFile(id: $id, file: $file) {
        id
        fog_id
        path
        mimetype
        name
        size
        deleted
    }
}`;


// WEBPACK FOOTER //
// ./src/graphql/mutations/files.js